import useBundleTranslation from 'i18n';
import { useAppBuilderContext } from 'app/app/editor/context';
import { Box, MenuItem } from '@mui/material';
import { getNodeByUid } from 'app/app/editor/page/getNodeByUid';
import { IMenuItem } from 'app/app/editor/tabs/elements/layout/context-menu/index';
import styles from 'app/app/editor/tabs/elements/layout/context-menu/ContextMenu.styles';
import { faScissors } from '@fortawesome/free-solid-svg-icons/faScissors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function MenuItemCut({ openWithUid, handleClose }: IMenuItem) {
    const { t } = useBundleTranslation(['app/portal-page-builder']);
    const ctx = useAppBuilderContext();
    if (openWithUid == 'page') {
        return null;
    }
    return (
        <MenuItem
            onClick={() => {
                const node = getNodeByUid(ctx.page.layout, openWithUid);
                if (node) {
                    ctx.setCopyBuffer({ node: structuredClone(node), cut: true });
                }
                handleClose();
            }}
        >
            <Box sx={{ ...styles.iconHolder, fontSize: '14px' }}>
                <FontAwesomeIcon icon={faScissors} />
            </Box>
            <Box>{t('node_context_menu.cut')}</Box>
        </MenuItem>
    );
}
